import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getImageUrl } from "@msys/common";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { IconButton, ImageList } from "@mui/material";
import { is3dModel, isImage, } from "../attachments/helpers.js";
import { useIconButtonLightStyles } from "../button/useIconButtonStyles.js";
import { ImageListItem } from "../image/ImageListItem.js";
import { ThreeDGenericImage } from "../threeD/ThreeDGenericImage.js";
const DEFAULT_IMAGE_SIZE = 240; // TODO: is this a good generic value
export const GalleryGrid = ({ selectedIndex, images = [], handleClick, handleDelete, columns = 2, style, idPrefix = "msys-gallery-grid-", showDeleteButton = false, }) => {
    return images.length > 0 ? (_jsx(ImageList, { style: {
            width: "100%",
            ...style,
        }, cols: columns, children: images.map((image, index) => (_jsxs(ImageListItem, { id: `${idPrefix}${image.id}`, onClick: handleClick
                ? e => {
                    e.stopPropagation();
                    handleClick(index, image);
                }
                : undefined, role: "button", "$clickable": true, "$selected": selectedIndex === index, children: [isImage(image) ? (_jsx("img", { draggable: false, src: getImageUrl({ url: image.url, width: DEFAULT_IMAGE_SIZE }), srcSet: `${getImageUrl({
                        url: image.url,
                        width: DEFAULT_IMAGE_SIZE,
                        scaling: 2,
                    })} 2x`, alt: image.title, loading: "lazy" })) : is3dModel(image) ? (_jsx(ThreeDGenericImage, {})) : null, showDeleteButton && handleDelete && (_jsx(StyledDeleteButton, { onClick: (event) => {
                        event.stopPropagation();
                        handleDelete(image);
                    }, style: { zIndex: 12 } }))] }, image.id))) })) : null;
};
const StyledDeleteButton = ({ style, ...props }) => {
    const { classes } = useIconButtonLightStyles();
    return (_jsx(IconButton, { classes: classes, style: {
            position: "absolute",
            bottom: "4px",
            right: "4px",
            ...style,
        }, size: "small", color: "primary", ...props, children: _jsx(DeleteIcon, { fontSize: "inherit" }) }));
};
//# sourceMappingURL=GalleryGrid.js.map